module.exports = __webpack_public_path__ + "img/40_8.d049c734.png";